export const gameLayers = {
  background: 'background',
  character: 'character',
  fishPopup: 'fishPopup',
  transition: 'transition',
};

export const FISH_ANIMATION_NAMES = {
  Fish: 'fish',
  Shark: 'shark',
};

export const CHARACTER_ANIMATION_NAMES = {
  Idle: 'idle',
  Shark: 'sharkEnd',
  Fishing: 'fishing',
};

export const BACKGROUND_ANIMATION_NAME = {
  Idle: 'animation',
  Shake: 'animation1',
  Sharks: 'animation2',
  MarlinFish: 'animation3',
  animation4: 'animation4',
};

export const SHARK_TYPE = 2;
export const SHARK_SKIN_NAME = 'shark';

export const fishingCountdownDeductionValues = {
  deductionValue: 0.1,
  intervalDelay: 100,
  precision: 1,
};

export const fishOddByIndex = [
  1, 0.5, 0, 1.2, 1.4, 1.6, 1.8, 2, 2.2, 2.4, 2.6, 2.8, 3, 3.2, 3.4, 3.6, 3.8, 4, 4.2, 4.4, 4.8, 5,
];

export const FISHING_GAME_ID = 49;

export const DURATION_FROM_FISH = 5.5;

export const FishingOddConfigWeb = {
  fontFamily: 'Arial',
  fontSize: 24,
  fill: 0xffffff,
  align: 'center',
  fontWeight: 'bold',
};

export const FishingOddConfigMobile = {
  fontFamily: 'Arial',
  fontSize: 24,
  fill: 0xffffff,
  align: 'center',
  fontWeight: 'bold',
};
